import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/17_spinner.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const Spinner: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default Spinner;
